import { NavLink } from "react-router";
import parse from 'html-react-parser';
import type { Pages } from "../../types/Pages";
import { useTrads } from "../../contexts/trads/useTrads";
import PageManage from "./PageManage";



function PagesItem({page}:{page:Pages}) {
    const {translate}=useTrads();


    return (
        <div className="row">
            <div className="col-9">
                <h2>{page.titre}</h2>
                <div>
                    {parse(page.texte)}
                </div>
            </div>
            <div className="col-3">
                <NavLink to={`/pages/${page.id.toString()}/edit`}> {translate('btn_edit')}</NavLink>
                <PageManage page={page}></PageManage>
            </div>
        </div>
    );
}
export default PagesItem;